import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ActionListHistory,
  ActionListHistoryTypes,
  ActionListsHistoryStoreService,
  ActionListStatuses,
} from '../../action-lists-history.store.service';
import { ToggleEvent } from '../common';

export interface Retry {
  historyItem: ActionListHistory;
}

@Component({
  selector: 'app-number-of-accounts',
  templateUrl: './number-of-accounts.component.html',
  styleUrls: ['./number-of-accounts.component.scss'],
  standalone: false,
})
export class NumberOfAccountsComponent {
  public readonly actionListStatuses = ActionListStatuses;
  public readonly actionListHistoryTypes = ActionListHistoryTypes;

  @Input() readonly history: ActionListHistory;
  @Input() isErrorShowing = false;

  @Output() readonly retryImport = new EventEmitter<Retry>();
  @Output() readonly toggleErrors = new EventEmitter<ToggleEvent>();

  constructor(private readonly store: ActionListsHistoryStoreService) {}

  handleRetryClicked(history: ActionListHistory): void {
    const event: Retry = {
      historyItem: history,
    };
    this.retryImport.emit(event);
  }

  downloadSkippedFile(history: ActionListHistory): void {
    this.store.downloadFile(history.skippedFile);
  }

  toggleInlineErrors(historyItem: ActionListHistory): void {
    const event: ToggleEvent = {
      itemId: historyItem.itemId,
      showErrors: !this.isErrorShowing,
    };
    this.toggleErrors.emit(event);
  }
}
